/**
 * Get blog preview heading color based on index
 * @param index in list of the blog
 * @returns class with color
 */
export function determineColor(index: number) {
    const cnt = index % 5;
    if(cnt === 0) {
        //return "12px solid var(--divelit-lemon)";
        return "b-top-divelit-lemon-12";
    }
    else if(cnt === 1) {
        //return "12px solid var(--divelit-lime)";
        return "b-top-divelit-lime-12";
    }
    else if(cnt === 2) {
        //return "12px solid var(--divelit-grass)";
        return "b-top-divelit-grass-12";
    }
    else if(cnt === 3) {
        //return "12px solid var(--divelit-cucumber)";
        return "b-top-divelit-cucumber-12";
    }
    else if(cnt === 4) {
        //return "12px solid var(--divelit-plum)";
        return "b-top-divelit-plum-12";
    }
}